<template>
    <section class="page-content settings">
        <div class="wrap btn-position-wrap">
            <div class="exports-settings-list">
                <div class="item-wrap" v-for="exports in exportsList">
                    <div class="line-item hovered-line">
                        <div class="left-item">
                            <div class="el exports-item" v-on:click="showCurrentExport(exports.id)">
                                <h3>{{ exports.requested_time }} </h3>
                                <h3>{{ exports.fulfilled_time }} </h3>
                                <h3>{{ exports.file_url }} </h3>
                            </div>
                        </div>
                        <div class="right-item">
                            <md-button v-if="exports.export_id !== currentExport.export_id" class="md-icon-button" @click="confirmDelete(exports)">
                                <md-icon>delete</md-icon>
                            </md-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import {deleteExports} from '../../services/ExportsService.js';

export default {
  data () {
    return {
      filterString: ''
    };
  },
  computed: {
    ...mapGetters('client', ['clientActive', 'currentClient']),
    ...mapGetters('exports', ['exportsList', 'loadSingleExports'])
  },
  methods: {
    ...mapActions('exports', ['loadExportsList']),
    loadExports () {
      if (this.clientActive) {
        this.loadExportsList(this.currentClient.id);
      } else {
        this.loadExportsList();
      }
    },
    deleteExports () {
      let exportIds = [];
      if (this.checked.length > 0) {
        for (let exportIndex of this.checked) {
          exportIds.push(this.exports[exportIndex].id);
        }
        deleteExports(this.currentClient.id, exportIds);
        this.emptyChecked();
        this.showDialog = false;
      }
      this.loadClientToursList(this.currentClient.id);
    },
    showCurrentExport (exportId) {
      if (exports.id === exportId) {
        this.loadSingleExports(exports);
      }
    }
  },
  mounted () {
    this.loadExports();
  }
};
</script>
<style lang="scss" scoped>
.bottom-btn-position {
    position: fixed !important;
    right: 12px !important;
    bottom: 32px !important;
    width: 500px;
    padding-right: 35px;

    button {
        z-index: 15;
    }
}

.wrap {
    padding-top: 0 !important;
}

.hovered-line:hover {
    background-color: rgba(0, 0, 0, 0.2);
}

.user-item {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/client/ExportDetailsTab.vue